document.addEventListener("turbolinks:load", function() {
  const activeTab = document.querySelector('.tabs__button.is-active');
  const scrollContainer = document.querySelector('.tabs__button-wrapper');
  
  if (activeTab && scrollContainer) {
    const tabOffset = activeTab.getBoundingClientRect().left;
    const containerOffset = scrollContainer.getBoundingClientRect().left;
    const offset = tabOffset - containerOffset - 16; // Assuming 1rem = 16px
    scrollContainer.scrollLeft = offset;
  }
});
